module.exports = __webpack_public_path__ + "static/hangry-75fcf2b95530bcbc21af8b90f2d4a05f.jpg";